import { render, staticRenderFns } from "./Toc.vue?vue&type=template&id=fa5ab12e&scoped=true"
import script from "./Toc.vue?vue&type=script&lang=js"
export * from "./Toc.vue?vue&type=script&lang=js"
import style0 from "./Toc.vue?vue&type=style&index=0&id=fa5ab12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5ab12e",
  null
  
)

export default component.exports